import type { BarChart } from "@acto/genui-components-schema";
import { useLocale } from "@acto/web-common/locales";
import { useCurrencyContext } from "@acto/taskpane/core/contexts/TenantSettingsContext";
import { asCurrencyCode } from "@acto/taskpane/core/utils/currencyCode";

export function useChartDisplay(chart: BarChart) {
  const { locale: uiLocale } = useLocale();
  const tenantCurrency = useCurrencyContext();

  return {
    locale: chart.meta?.locale ?? uiLocale,
    currency: chart.meta?.currency ? asCurrencyCode(chart.meta.currency) : tenantCurrency,
    leadSeries: chart.y.find((series) => !series.style) ?? chart.y[0],
    comparisonSeries: chart.y.find((series) => series.style === "comparison"),
  };
}
